<template>
    <v-card class="text-center">
        <v-toolbar dark color="secondary" class="white--text mb-5" dense>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                Post Order
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark icon left @click="$store.state.posting.dialog = false"
                ><v-icon>mdi-close</v-icon></v-btn
            >
        </v-toolbar>
        <v-form ref="form" lazy-validation>
            <v-card-text>
                <v-container v-if="componentDialog" fluid>
                    <table class="tbl-trs">
                        <thead>
                            <tr>
                                <th>OrderID</th>
                                <th>Order Status</th>
                                <th>Customer</th>
                                <th>Terminal</th>
                                <th>Station</th>
                                <th>Supplier</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ orderInfo[0]['OrderID'] }}</td>
                                <td>{{ orderInfo[0]['OrderStatus'] }}</td>
                                <td>
                                    <v-combobox
                                required
                                v-model="orderInfo[0]['Customer']"
                                :items="customers"
                                :item-text="'Name'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Customer is required']"
                                class="mx-3"
                                :disabled="isModal"
                                style="font-size: 13px; margin: 0px;padding: 0px;"
                                @change="changeCustomer"
                                auto-select-first
                                hide-details
                            ></v-combobox>    
                                </td>
                                <td>
                                      <v-combobox
                                required
                                v-model="orderInfo[0]['Terminal']"
                                :items="terminals"
                                :item-text="'Name'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Terminal is required']"
                                class="mx-3 "
                                :disabled="isModal"
                                style="font-size: 13px; margin: 0px;padding: 0px;"
                                @change="changeTerminal"
                                auto-select-first
                                hide-details
                            ></v-combobox></td>
                                <td>
                                    <v-combobox
                                    
                                required
                                v-model="orderInfo[0]['Station']"
                                :items="stations"
                                :item-text="'Name'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Station is required']"
                                class="mx-3 "
                                :disabled="isModal"
                                style="font-size: 13px; margin: 0px;padding: 0px;"
                                @change="changeStation"
                                auto-select-first
                                hide-details
                            ></v-combobox>
                                </td>
                                <td>
                                    <v-combobox
                                    
                                required
                                v-model="orderInfo[0]['Supplier']"
                                :items="suppliers"
                                :item-text="'Supplier'"
                                :item-value="'id'"
                                :rules="[v => !!v || 'Suppliers is required']"
                                class="mx-3 "
                                :disabled="true"
                                style="font-size: 13px; margin: 0px;padding: 0px;"
                                @change="changeSupplier"
                                auto-select-first
                                hide-details
                            ></v-combobox>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="tbl-trs">
                        <thead>
                            <tr>
                                <th>Shift Detail</th>
                                <th>SplitType</th>
                                <th>Date</th>
                                <th>Shift *</th>
                                <th>Driver</th>
                                <th>Truck</th>
                                <th>Trailer</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ orderInfo[0]['ShiftDetail'] }}</td>
                                <td>{{ orderInfo[0]['SplitType'] }}</td>
                                <td>{{ orderInfo[0]['ShiftDate'] }}</td>
                                <td>{{ orderInfo[0]['Shift'] }}</td>
                                <td>{{ orderInfo[0]['Driver'] }}</td>
                                <td>{{ orderInfo[0]['Truck'] }}</td>
                                <td>{{ orderInfo[0]['Trailer'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                         <v-row class="divs">
                        <v-col cols="4" class="divs">
                            <v-textarea
                                v-model="orderInfo[0]['DispatchComments']"
                                class="mx-2"
                                label="Dispatch Comments"
                                rows="3"
                                prepend-icon="mdi-comment"
                                
                                :disabled="isModal"
                            ></v-textarea>
                        </v-col>
                        <v-col cols="4" class="divs">
                            <v-textarea
                                v-model="orderInfo[0]['GPSComments']"
                                class="mx-2"
                                label="GPS Comments"
                                rows="3"
                                prepend-icon="mdi-comment"
                                
                                :disabled="isModal"
                            ></v-textarea>
                        </v-col>
                        
                        <v-col cols="4" class="divs">
                            <v-textarea
                                v-model="orderInfo[0]['SpecialInstructions']"
                                class="mx-2"
                                label="Special Instructions"
                                rows="3"
                                prepend-icon="mdi-comment"
                                
                                :disabled="isModal"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                    <v-row class="divs">
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Bill of Lading"
                                v-model="orderInfo[0]['BOL']"
                                
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Pickup Date"
                                placeholder="yyyy/mm/dd"
                                v-mask="'####/##/##'"
                                :rules="dateRules"
                                type="tel"
                                :value="orderInfo[0]['DatePickup']"
                                id="orDDatePickup"
                                style="color:#000;"
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Pickup Time"
                                v-model="orderInfo[0]['TimePickup']"
                                type="tel"
                                v-mask="'##:##'"
                                :rules="timeRules"
                                
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="3" class="divs">
                            <v-text-field
                                label="Delivery Date"
                                id="orDDateDelivered"
                                :value="orderInfo[0]['DateDelivered']"
                                placeholder="yyyy/mm/dd"
                                v-mask="'####/##/##'"
                                style="color:#000;"
                                type="tel"
                                :rules="dateRules"
                                
                                dense
                                :disabled="isModal"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="divs">
                        <v-spacer/>
                        <v-col cols="2 " class="divs">
                            <v-checkbox
                                style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                label="P.A.S"
                                v-model="
                                    orderInfo[0][
                                        'PAS'
                                    ]
                                "
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2 " class="divs">
                            <v-checkbox
                                style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                label="BOL"
                                v-model="
                                    orderInfo[0][
                                        'ppwBOL'
                                    ]
                                "
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2 " class="divs">
                            <v-checkbox
                                style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                label="CTI"
                                v-model="
                                    orderInfo[0][
                                        'ppwCTI'
                                    ]
                                "
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2 " class="divs">
                            <v-checkbox
                                style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                label="Safe Discharge Sheet"
                                v-model="
                                    orderInfo[0][
                                        'ppwSDC'
                                    ]
                                "
                            ></v-checkbox>
                        </v-col>
                        <v-col cols="2 " class="divs">
                            <v-checkbox
                                style="margin-top: 0px;font-size: 10px; margin: 0px;padding: 0px; "
                                label="ReadyToTransact"
                                v-model="
                                    orderInfo[0][
                                        'ReadyToTransact'
                                    ]
                                "
                            ></v-checkbox>
                        </v-col>
                        <v-spacer/>
                    </v-row>
                </v-container>
                <v-row justify="center" class="divs">
                    <v-col cols="1" class="divs">
                        <v-progress-circular
                            :size="70"
                            :width="7"
                            indeterminate
                            v-if="progress"
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-text class="divs"  v-if="componentDialog" >
             
                  <v-container grid-list-xs>
                          <table class="tbl-trs">
                        <thead>
                            <tr>
                                  <template  v-for="(item, i) in headerProducts"  >
                                
                                    <th  v-bind:key="i">{{ item.text }}</th>
                               
                            </template>
                            </tr>
                        </thead>
                        <tbody>
                            <template  v-for="(item, i) in productsOrder" >
                                <tr v-bind:key="i">
                                    <td>{{ item.ProductCode }}</td>
                                    <td>
                                         <v-combobox
                                required
                                v-model="productsOrder[i]['Product']"
                                :items="products"
                                :item-text="'Product'"
                                :item-value="'id'"
                                class="mx-3"
                                style="font-size: 13px; margin: 0px;padding: 0px;"
                                @change="changeProduct(productsOrder[i],i)"
                                auto-select-first
                                hide-details
                                :disabled="isModal"
                            ></v-combobox>   
                                    </td>
                                    <td>{{ item.Quantity }}</td>
                                    <td><input :id="'dispqty'+i" style="width:70px" type="text"  v-model="productsOrder[i]['DispatchedQuantity']" 
                                     :disabled="isModal"></td>
                                    <td><input :id="'delqty'+i"  style="width:70px" type="text" v-model="productsOrder[i]['DeliveredQuantity']" 
                                    :disabled="isModal"></td>
                                    <td><input :id="'tpqty'+i" 
                                :disabled="isModal"  style="width:70px" type="text" 
                            v-model="productsOrder[i]['TempAdjQuantity']"></td>
                                </tr>

                            </template>
                        </tbody>
                    </table>
                  </v-container>
            </v-card-text>
        </v-form>
        <v-divider></v-divider>

        <v-card-actions v-show="!isModal">
            <v-spacer></v-spacer>
            <v-btn
                color="secondary"
                @click="$store.state.posting.dialog = false"
                >Close</v-btn
            >
            <v-btn color="secondary" @click="validate()">Save</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import axios from 'axios';
import { mask } from 'vue-the-mask';
export default {
    name: 'OrderData',
    directives: { mask },
    props: ['isModal'],
    data: function() {
        return {
            products:[],
            terminals:[],
            customers:[],
            stations: [],
            suppliers:[],
            supplier:[],
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            headerProducts: [
                { text: 'ProductCode', width: '2' },
                { text: 'Product', width: '2' },
                { text: 'Requested', width: '1' },
                { text: 'Dispatched', width: '1' },
                { text: 'Delivered', width: '1' },
                { text: 'Temp. Adj.', width: '1' }
            ],
            timeRules: [
                v => parseInt(v[0] + v[1]) <= 23 || 'Time Incorrect',
                v => parseInt(v[3] + v[4]) <= 59 || 'Time Incorrect'
            ],
            orderInfo: [],
            productsOrder: [],
            componentDialog: false,
            progress: false
        };
    },
    mounted() {
        this.loadOrderInfo(this.$store.state.orderInfo.orderId);
        this.loadProductsOrder(this.$store.state.orderInfo.orderId);
        this.loadAllProducts();
        this.loadCustomers();
        this.loadStations();
        this.loadTerminals();
        this.loadSuppliers();
    },
    methods: {
         loadTerminals: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('terminal/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.terminals = response.data.data;
                    console.log(this.terminals);
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
            this.$store.state.isLoading = false;
        },
        loadCustomers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('customer/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.customers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadStations: function() {
            axios
                .get('station/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.stations = response.data.data;
                    console.log(this.stations);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadOrderInfo: function(orderID) {
            this.$store.state.isLoading = true;
            this.progress = true;
            axios
                .get('order/info/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.orderInfo = response.data.data;
                    console.log(this.orderInfo);
                    this.componentDialog = true;
                    this.progress = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadProductsOrder: function(orderID) {
            axios
                .get('order-detail/order/' + orderID, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.productsOrder = response.data.data;
                    console.log(this.productsOrder);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        changeProduct: function(itm, idx){
            itm.ProductID = itm.Product.ProductID;
            itm.Product = itm.Product.Product;
            this.getCode(itm, idx);
        },
        changeCustomer: function(){
            console.log( this.orderInfo[0]['CustomerID']);
            this.orderInfo[0]['CustomerID'] =this.orderInfo[0]['Customer'].id;
            console.log( this.orderInfo[0]['CustomerID']);
            this.updateCodes();
        },
          changeStation: function(){
            console.log( this.orderInfo[0]['StationID']);
            this.orderInfo[0]['StationID'] =this.orderInfo[0]['Station'].id;
            console.log( this.orderInfo[0]['StationID']);
        },
        changeSupplier: function(){
            console.log( this.orderInfo[0]['SupplierID']);
            this.orderInfo[0]['SupplierID'] = this.orderInfo[0]['Supplier'].id;
            console.log( this.orderInfo[0]['SupplierID']);
            this.updateCodes();
        },
        changeTerminal: function(){
            console.log( this.orderInfo[0]['TerminalID']);
            this.orderInfo[0]['TerminalID'] = this.orderInfo[0]['Terminal'].id;
            console.log( this.orderInfo[0]['TerminalID']);
            this.updateCodes();
        },
        updateCodes: function() {
                this.productsOrder.forEach((element, i )=> {
                    this.getCode(element,i);
                });
        },
        getCode: function(item,idx) {
            var params = {
                Customer: this.orderInfo[0]['CustomerID'],
                Terminal: this.orderInfo[0]['TerminalID'],
                Supplier: this.orderInfo[0]['SupplierID'],
                Product: item.ProductID
            }
            console.log(params,idx);
             axios
                 .post('get-product-code-number', params,{
                     headers: {
                         Authorization: 'Bearer ' + this.$store.state.token
                     }
                 })
                 .then(response => {
                     this.productsOrder[idx].ProductCode = response.data;
                 })
                 .catch(function(error) {
                     console.log(error);
                    
                 });
        },
        saveOrderData: function() {
            this.$store.state.isLoading = true;

            var params = {
                Terminal: this.orderInfo[0]['TerminalID'],
                Station: this.orderInfo[0]['StationID'],
                Customer: this.orderInfo[0]['CustomerID'],
                Supplier: this.orderInfo[0]['SupplierID'],
                BillOfLading: this.orderInfo[0]['BOL'],
                DateTerminalPick: this.getMsk('orDDatePickup'),
                TimeTerminalPick: this.orderInfo[0]['TimePickup'],
                DateDelivered: this.getMsk('orDDateDelivered'),
                TimeDelivered: this.orderInfo[0]['TimeDelivered'],
                ppwBOL: this.orderInfo[0]['ppwBOL'],
                ppwCTI: this.orderInfo[0]['ppwCTI'],
                ppwSDC: this.orderInfo[0]['ppwSDC'],
                PAS: this.orderInfo[0]['PAS'],
                ReadyToTransact: this.orderInfo[0]['ReadyToTransact'],
            };
            axios
                .put('order/' + this.$store.state.orderInfo.orderId, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.$store.state.transacting.watch = true;
                    console.log(response);
                    for (const i in this.productsOrder) {
                        var orderDetailID = this.productsOrder[i].id;
                        var params = {
                            DeliveredQuantity: this.productsOrder[i][
                                'DeliveredQuantity'
                            ],
                            TempAdjQuantity: this.productsOrder[i][
                                'TempAdjQuantity'
                            ],
                            Temperature: this.productsOrder[i]['Temperature'],
                            Density: this.productsOrder[i]['Density'],
                            ProductType: this.productsOrder[i]['ProductID'],
                            ProductCode: this.productsOrder[i]['ProductCode']
                        };
                        var str = this.$store;
                        axios
                            .put('order-detail/' + orderDetailID, params, {
                                headers: {
                                    Authorization:
                                        'Bearer ' + this.$store.state.token
                                }
                            })
                            .then(response => {
                                console.log(response);
                                this.$store.state.posting.dialog = false;
                                this.$store.dispatch('setSnackbar', {
                                    color: 'success',
                                    text: 'Order saved successfully'
                                });
                            })
                            .catch(function(error) {
                                console.log(error);
                                if (error.response.status === 403) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'You do not have the permission to use this function.'
                                    });
                                }
                                if (error.response.status === 500) {
                                    str.dispatch('setSnackbar', {
                                        color: 'error',
                                        text:
                                            'An error has ocurred, please try again.'
                                    });
                                }
                            });
                    }
                })
                .catch(function(error) {
                    console.log(error);

                    this.$store.state.transacting.watch = false;
                });
            this.$store.state.isLoading = false;
        },
        loadAllProducts: function() {
            this.$store.state.isLoading = true;
            axios
                .get('product/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.products = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        loadSuppliers: function() {
            this.$store.state.isLoading = true;
            axios
                .get('supplier/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.suppliers = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$store.state.isLoading = false;
        },
        validate() {
            this.saveOrderData();
        },
        cancel: function() {
            console.log('cancel');
        },
        getMsk: function(id) {
            return document.getElementById(id).value;
        }
    }
};
</script>
<style>
div.chps {
    float: left;
}
.chps > span {
    width: 100%;
}
div.divs {
    margin-top: 10px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
}
table.tbl-trs {
    border-collapse: collapse;
    font-size: 12px;
    color: #000;
    width: 100%;
}
.tbl-trs,
td {
    font-size: 13px;
}
.tbl-trs input {
    color: #000;
}
.tbl-trs input {
    width: 45px;
    box-sizing: border-box;
    border: none;
    border-bottom: 2px solid #e1e1e1;
}
th {
    border-collapse: collapse;
}

td {
    height: 0px;
}
td:hover {
    background: none;
}
</style>
